import React, { FunctionComponent } from 'react';

import { PaymentFrequencyStep as CommonPaymentFrequency } from 'scenes/common/components/Steps';

import { LandlordFullPageProps } from 'scenes/landlord/types';
import {
  getPaymentFrequency,
  getSelectedInsuranceOption,
} from 'scenes/landlord/selectors';

export const PaymentFrequencyStep: FunctionComponent<Pick<
  LandlordFullPageProps,
  'funnelState' | 'onNext'
>> = ({ funnelState, onNext }) => {
  const { coverType, premium } = getSelectedInsuranceOption(funnelState);
  return (
    <CommonPaymentFrequency
      defaultStateValue={getPaymentFrequency(funnelState)}
      coverType={coverType}
      premium={premium}
      onNext={onNext}
    />
  );
};

export default PaymentFrequencyStep;
